import { API_ENDPOINT, fetchWithAuth, parseApiResponse } from ".";

export interface AdminTicketType {
  id: number;
  eventId: number;
  name: string;
  description: string | null;
  pricePence: number;
  currency: string;
  quantityTotal: number | null;
  quantitySold: number;
  status: string;
  category: string | null;
  membershipTier: string | null;
  itemOrderedLabel: string | null;
  typeName?: string | null;
  ticketSetName?: string | null;
  pricingPeriod?: string | null;
}

export interface TicketTypeInput {
  name: string;
  description?: string;
  pricePence: number;
  currency?: string;
  quantityTotal?: number;
  status?: "active" | "inactive";
  category?: string | null;
  membershipTier?: string | null;
  itemOrderedLabel?: string | null;
}

export async function listEventTickets(
  eventId: number,
): Promise<AdminTicketType[]> {
  const response = await fetchWithAuth(
    `${API_ENDPOINT}/events/${eventId}/tickets`,
  );
  const data = await parseApiResponse<{ tickets: AdminTicketType[] }>(response);
  return data.tickets;
}

export async function createEventTicket(
  eventId: number,
  input: TicketTypeInput,
): Promise<AdminTicketType> {
  const response = await fetchWithAuth(
    `${API_ENDPOINT}/events/${eventId}/tickets`,
    {
      method: "POST",
      body: JSON.stringify(input),
    },
  );
  const data = await parseApiResponse<{ ticket: AdminTicketType }>(response);
  return data.ticket;
}

export async function updateEventTicket(
  ticketTypeId: number,
  input: Partial<TicketTypeInput>,
): Promise<AdminTicketType> {
  const response = await fetchWithAuth(
    `${API_ENDPOINT}/tickets/${ticketTypeId}`,
    {
      method: "PATCH",
      body: JSON.stringify(input),
    },
  );
  const data = await parseApiResponse<{ ticket: AdminTicketType }>(response);
  return data.ticket;
}

export async function deactivateEventTicket(ticketTypeId: number): Promise<void> {
  const response = await fetchWithAuth(
    `${API_ENDPOINT}/tickets/${ticketTypeId}`,
    { method: "DELETE" },
  );
  await parseApiResponse(response);
}
